import { render, staticRenderFns } from "./lnk-valuelist-cascader.vue?vue&type=template&id=c2613b62&scoped=true&"
import script from "./lnk-valuelist-cascader.vue?vue&type=script&lang=js&"
export * from "./lnk-valuelist-cascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2613b62",
  null
  
)

export default component.exports